import { render, staticRenderFns } from "./KnowledgeView.vue?vue&type=template&id=459c4d1e&scoped=true&"
import script from "./KnowledgeView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeView.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeView.vue?vue&type=style&index=0&id=459c4d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c4d1e",
  null
  
)

export default component.exports